import { Injectable } from '@angular/core';
import { OrderLanguageEnum } from 'src/generated/graphql';

const MMA = 1153;
const GPM = 0.2;
const PSD = 0.0698;
const VSD = 0.1252;
const EE_INCOME_TAX_RATE = 0.22;
const EE_UNEMPLOYMENT_RATE = 0.016;
const EE_MONTHLY_TAX_FREE_INCOME = 700;

const FULL_NPD_LT = 747;
const COEF_LOW_SALARY_LT = 0.49;
const AVERAGE_MONTHLY_SALARY_LT = 2312.15;
const GPM_YEARLY_LIMIT_20 = 36 * AVERAGE_MONTHLY_SALARY_LT;
const GPM_YEARLY_LIMIT_25 = 60 * AVERAGE_MONTHLY_SALARY_LT;
const GPM_MONTHLY_LIMIT_20 = GPM_YEARLY_LIMIT_20 / 12;
const GPM_MONTHLY_LIMIT_25 = GPM_YEARLY_LIMIT_25 / 12;

@Injectable({
  providedIn: 'root'
})
export class SalaryCalculatorService {

  static countryISO = '';
  constructor() { }


  getNPD(monthlyIncome) {
    return 400 - 0.18 * (monthlyIncome - MMA);
  }

  /** Netto from Brutto */
  getMonthlyNetto(monthlyBrutto) {
    // return monthlyBrutto - (monthlyBrutto - this.getNPD(monthlyBrutto)) * GPM - monthlyBrutto * (PSD + VSD);
    // NOTE: 0.18 and 400 from forumla in NPD
    let brutto = 0;
    switch (SalaryCalculatorService.countryISO) {
      case 'lt':
        brutto = this.getMonthlyNettoForLT(monthlyBrutto);
        break;

      case 'lv':
        brutto = this.getMonthlyNettoForLV(monthlyBrutto);
        break;

      case 'ee':
        brutto = this.getMonthlyNettoForEE(monthlyBrutto);
        break;

      default:
        brutto = this.getMonthlyNettoForLT(monthlyBrutto);
        break;
    }
    return brutto;
  }

  getMonthlyNettoForLT(monthlyBrutto) {
    const taxableForGpm = Math.max(0, monthlyBrutto - this.getNPDLT(monthlyBrutto));
    return monthlyBrutto - this.getLtMonthlyGpm(taxableForGpm) - monthlyBrutto * (PSD + VSD);
  }

  getMonthlyNettoForLV(monthlyBrutto) {
    return monthlyBrutto - (monthlyBrutto * 10.5 / 100) - ((monthlyBrutto - (monthlyBrutto * 10.5 / 100)) * 20 / 100);
  }

  getMonthlyNettoForEE(monthlyBrutto) {
    const unemployment = monthlyBrutto * EE_UNEMPLOYMENT_RATE;
    const taxableForIncomeTax = Math.max(0, monthlyBrutto - unemployment - EE_MONTHLY_TAX_FREE_INCOME);
    return monthlyBrutto - unemployment - taxableForIncomeTax * EE_INCOME_TAX_RATE;
  }

  /** Netto from Brutto ends here */



  /** Brutto from Netto */
  getMonthlyBruttoFromNetto(monthlyNetto) {

    let netto = 0;

    switch (SalaryCalculatorService.countryISO) {
      case 'lt':
        netto = this.getMonthlyBruttoFromNettoForLT(monthlyNetto);
        break;

      case 'lv':
        netto = this.getMonthlyBruttoFromNettoForLV(monthlyNetto);
        break;

      case 'ee':
        netto = this.getMonthlyBruttoFromNettoForEE(monthlyNetto);
        break;

      default:
        netto = this.getMonthlyBruttoFromNettoForLT(monthlyNetto);
        break;
    }
    return netto;
  }

  getMonthlyBruttoFromNettoForLT(monthlyNetto) {
    if (monthlyNetto <= 0) {
      return 0;
    }

    let low = 0;
    let high = Math.max(1, monthlyNetto / (1 - (PSD + VSD + GPM)));

    while (this.getMonthlyNettoForLT(high) < monthlyNetto) {
      high *= 2;
    }

    for (let i = 0; i < 60; i++) {
      const mid = (low + high) / 2;
      const nettoAtMid = this.getMonthlyNettoForLT(mid);
      if (nettoAtMid < monthlyNetto) {
        low = mid;
      } else {
        high = mid;
      }
    }

    return (low + high) / 2;
  }

  getMonthlyBruttoFromNettoForLV(monthlyNetto) {
    return monthlyNetto / (1 - 0.105 - 0.179);
  }

  getMonthlyBruttoFromNettoForEE(monthlyNetto) {
    if (monthlyNetto <= 0) {
      return 0;
    }

    let low = 0;
    let high = Math.max(1, monthlyNetto / (1 - (EE_UNEMPLOYMENT_RATE + EE_INCOME_TAX_RATE)));

    while (this.getMonthlyNettoForEE(high) < monthlyNetto) {
      high *= 2;
    }

    for (let i = 0; i < 60; i++) {
      const mid = (low + high) / 2;
      const nettoAtMid = this.getMonthlyNettoForEE(mid);
      if (nettoAtMid < monthlyNetto) {
        low = mid;
      } else {
        high = mid;
      }
    }

    return (low + high) / 2;
  }

  /** Brutto from Netto ends here */
  private getNPDLT(monthlyBrutto) {
    const npd = FULL_NPD_LT - COEF_LOW_SALARY_LT * (monthlyBrutto - MMA);
    return Math.max(0, Math.min(FULL_NPD_LT, npd));
  }

  private getLtMonthlyGpm(monthlyTaxableIncome: number) {
    if (monthlyTaxableIncome <= GPM_MONTHLY_LIMIT_20) {
      return monthlyTaxableIncome * 0.2;
    }
    if (monthlyTaxableIncome <= GPM_MONTHLY_LIMIT_25) {
      return GPM_MONTHLY_LIMIT_20 * 0.2 + (monthlyTaxableIncome - GPM_MONTHLY_LIMIT_20) * 0.25;
    }
    return GPM_MONTHLY_LIMIT_20 * 0.2
      + (GPM_MONTHLY_LIMIT_25 - GPM_MONTHLY_LIMIT_20) * 0.25
      + (monthlyTaxableIncome - GPM_MONTHLY_LIMIT_25) * 0.32;
  }
}
